import React, { Component } from 'react';

export default class Modal extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        // validate if the props changes
        if(prevProps.show != this.props.show) {
            $(this.refs.modal).modal(this.props.show ? 'show': 'hide');
        }
    }

    render() {
        const { Aceptar, onCloseModal2 } = this.props;

        return (
            <div className="modal" tabIndex="-1" role="dialog" ref="modal">
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Cancelar Factura Actual</h5>
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCloseModal2}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                            <p>¿Desea cancelar el CFDI Actual?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-custom-theme" onClick={Aceptar}>
                                <i className="fas fa-file-alt"></i> Aceptar
                            </button>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" aria-label="Close" onClick={onCloseModal2}>
                                    <i className="fas fa-window-close"></i> Cerrar
                            </button>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
        )
    }

}



// WEBPACK FOOTER //
// ./Public/src/js/util/modal/CancelarCFDI.jsx